const TableChart = ({ data }) => {

    return (
        <>
            {
                data.values.map((curData, idx) => {
                    const { Emission, Water, Waste, Energy, Year } = curData;
                    const total_ghg_emission = Emission['Total Scope 1 GHG Emissions'] + Emission['Total Scope 2 GHG Emissions'] + Emission['Total Scope 3 GHG Emissions'];

                    return (
                        <tr
                            key={idx}
                        >
                            <td>{Year}</td>
                            <td>{Emission['Total Scope 1 GHG Emissions']}</td>
                            <td>{Emission['Total Scope 2 GHG Emissions']}</td>
                            <td>{Emission['Total Scope 3 GHG Emissions']}</td>
                            <td>{total_ghg_emission}</td>
                            <td>{Energy['Energy consumed']}</td>
                            <td>{Water['Total Water withdrawn']}</td>
                            <td>{Water['Total Water discharged']}</td>
                            <td>{Water['Total Water recycled and reused']}</td>
                            <td>{Waste['Total Hazardous Waste']}</td>
                            <td>{Waste['Total Non-Hazardous Waste']}</td>
                            <td>{Waste['Total Waste Recycled']}</td>
                        </tr>
                    )
                })
            }
        </>
    )
}

export default TableChart;